import { RibbonProps, Type } from 'domain/constants/ribbons';
import { Formik, Form } from 'formik';
import { ComponentType } from 'react';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';

import DomainSearchInput from './components/DomainSearchInput';
import { DomainSearchDesignProps, DomainSearchTextProps, SearchInputCTAProps } from './models/types';
import Ribbon from '../Ribbon';
import useDomainSearchInput from './models/useDomainSearchInput';
import StickyCheckoutBar from './components/sticky-checkout';

interface OuterProps extends RibbonProps {
  text: DomainSearchTextProps;
  design: DomainSearchDesignProps;
  search: SearchInputCTAProps;
}

const ConnectedDomainSearchInput = ({
  id,
  name,
  colorway,
  design,
  text,
  layout,
  loading,
  search,
  hBaseline,
}: OuterProps) => {
  const {
    models: { domainName, ref, isSticky, basketCount },
    operations: { onSubmit },
  } = useDomainSearchInput({
    analytics: search?.analytics,
    redirect: search?.redirect,
    destination: search?.destination,
    tld: search?.tld,
  });

  return (
    <>
      {/* When redirect is set to true, we are not on DST, and the input should not be sticky */}
      <Formik
        initialValues={{ domainSearchTerm: domainName }}
        onSubmit={onSubmit}
        initialTouched={{ domainSearchTerm: domainName !== '' }}
      >
        <>
          <Ribbon
            id={id}
            name={name}
            type={Type.DOMAIN_SEARCH_START}
            colorway={colorway}
            layout={layout}
            loading={loading}
            flush={true}
          >
            <span ref={ref} className="domain-search-input-ribbon" />
            <Form method="get" data-testid="nonStickyForm">
              <DomainSearchInput
                isSticky={isSticky}
                text={text}
                design={design}
                search={search}
                colorway={colorway}
                hBaseline={hBaseline}
              />
            </Form>
          </Ribbon>
          <Form method="get">
            <StickyCheckoutBar
              colorway={colorway}
              basketCount={basketCount}
              isSticky={isSticky}
              placeholder={search?.placeholder}
              disabled={false}
              glyph={search?.glyph}
              label={search?.label}
              tld={search?.tld}
              ariaHidden={!isSticky}
            />
          </Form>
        </>
      </Formik>
    </>
  );
};

ConnectedDomainSearchInput.displayName = 'DomainSearchInput';

export default errorBoundary(visibilitySet(ConnectedDomainSearchInput)) as ComponentType<OuterProps>;
